module.exports = "<li class=\"uia-custom-action\">\n    <a ng-click=\"model.trackCustomAction()\">{{ name }}</a>\n</li>\n";